module.exports = __webpack_public_path__ + "static/img/mediaplanning.d2a845c1.png";